export default "__VITE_ASSET__Dttut3v1__"